import { Format } from './format'

// PLAN_PRICES_GENERATED_BY_SCRIPT

export const prices = {
  "daily": {},
  "hourly": {
    "meeting-rooms": 3500
  },
  "monthly": {
    "hot-desk-coworking": 40000,
    "private-office-8-10": 288000,
    "Virtual-Office-London-Mail-Forwarding": 3799,
    "virtual-office-whatsapp-for-business-number": 499,
    "Virtual-Office-London": 2299,
    "virtual-office-phone": 699,
    "Virtual-Office-London-Mail-Forwarding-addon": 1500
  },
  "yearly": {
    "Virtual-Office-London-Mail-Forwarding": 37999,
    "virtual-office-whatsapp-for-business-number": 4999,
    "Virtual-Office-London": 22999,
    "virtual-office-phone": 6990,
    "Virtual-Office-London-Mail-Forwarding-addon": 15000
  }
}

      const getFormattedPrices = (
  duration: 'monthly' | 'yearly' | 'hourly' | 'daily',
) => {
  return Object.entries(prices[duration]).reduce(
    (formattedPrices, [plan, price]) => {
      formattedPrices[plan] = Format.money(price)
      return formattedPrices
    },
    {} as { [key: string]: string },
  )
}

export const planPrice = {
  daily: getFormattedPrices('daily'),
  hourly: getFormattedPrices('hourly'),
  monthly: getFormattedPrices('monthly'),
  monthlyOnYearlyPlan: (plan: string) => {
    const yearlyPrice =
      Number(planPrice.yearly[plan].replace(/[^0-9.-]+/g, '')) * 100
    const priceParts = Format.money(Math.round(yearlyPrice / 12))?.split('.')
    const number = parseInt(priceParts[0].replace('£', '')) * 100
    const decimal = parseFloat(priceParts[1]) / 100
    const roundUp = decimal >= 0.5

    if (roundUp) {
      return `Under ${Format.money(number + 100)?.split('.')[0]}`
    }
    return `${Format.money(number)?.split('.')[0]}`
  },
  dailyOnYearlyPlan: (plan: string) => {
    const yearlyPrice =
      Number(planPrice.yearly[plan].replace(/[^0-9.-]+/g, '')) * 100

    return Math.floor(yearlyPrice / 360)
  },
  monthlyOnYearlyPlanFloat: (plan: string) => {
    const yearlyPrice = Number(planPrice.yearly[plan].replace(/[^0-9.-]+/g, ''))
    return Math.round(yearlyPrice / 12).toFixed(2)
  },
  yearly: getFormattedPrices('yearly'),
}

      